import { render, staticRenderFns } from "./PermissionResource.vue?vue&type=template&id=7b243cdc&"
import script from "./PermissionResource.vue?vue&type=script&lang=ts&"
export * from "./PermissionResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports